const nonProductionEnvironments = [
  "remo-conference-qa",
  "remo-conference-dev",
  "remo-conference-staging",
  "staging.remo.co",
];

const isTestEnvironment = (hostname: string) =>
  nonProductionEnvironments.some((nonProductionEnv) =>
    hostname.includes(nonProductionEnv),
  );

export type Environment = ReturnType<typeof getEnvironment>;

export const getEnvironment = () => {
  const { hostname } = window.location;

  if (isTestEnvironment(hostname)) {
    return "test";
  }

  switch (hostname) {
    case "live.remo.co":
      return "production";
    case "localhost":
      return "localhost";
    default:
      return "test";
  }
};
